// extracted by mini-css-extract-plugin
module.exports = {"block":"MyProducts_block__1llZ5"};